/**
 * Google strips HTML from descriptions, and the old page saved rich text. The
 * page edits plain text, so stored HTML is flattened once on load: block tags
 * become line breaks, list items get a dash, entities are decoded.
 */
export function htmlToPlainText(html: string): string {
    if (!html || !/[<&]/.test(html)) {
        return html
    }
    const text = html
        .replace(/<\s*br\s*\/?>/gi, '\n')
        .replace(/<\s*li[^>]*>/gi, '\n- ')
        .replace(/<\s*\/\s*(p|div|li|ul|ol|h[1-6]|blockquote)\s*>/gi, '\n')
        .replace(/<[^>]+>/g, '')
    const decoded = new DOMParser().parseFromString(text, 'text/html').documentElement.textContent ?? text
    return decoded
        .split('\n')
        .map((line) => line.replace(/\s+/g, ' ').trim())
        .filter((line) => line.length > 0)
        .join('\n')
        .trim()
}
